const CtaArrow = ({ className = "text-beige-30" }) => (
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    className={`shrink-0 ${className}`}
  >
    <path
      d="M1.54032 11.1396L1.41431 11.25L0.000266657 11.25L0.000266723 9.59766L3.41611 6.625L0.000266962 3.65234L0.000267029 2L1.41431 2L1.54032 2.11035L6.72754 6.625L1.54032 11.1396Z"
      fill="currentColor"
    />
  </svg>
);

export default CtaArrow;